module.exports = __webpack_public_path__ + "static/banner-mobile-cff385e7e21f890e96fa89690501d2ae.svg";